<template>
  <div class="form-container">
    <div class="form-header">
      <h2>Create New Video</h2>
    </div>
    <form @submit.prevent="handleSubmit" class="form">
      <VideoForm :channels="sortedChannels" ref="videoForm" />
      <div class="form-actions">
        <button type="submit" class="submit-button big">
          Create Video
        </button>
        <button type="button" class="cancel-button medium" @click="handleCancel">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, useTemplateRef, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import VideoForm from '@/components/VideoForm.vue';
import { isSuperuser } from '@/scripts/permissions';
import { handleApiError } from '@/scripts/shared-utils';

const route = useRoute();
const router = useRouter();
const videoForm = useTemplateRef('videoForm');
const channels = ref([]);

const sortedChannels = computed(() => {
  return [...channels.value].sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
});

const handleSubmit = async () => {
  try {
    const videoData = { ...videoForm.value.formData };
    const channelId = videoForm.value.formData.channel_id;
    await axios.post(`/api/channels/${channelId}/videos`, videoData);
    closeForm();
  } catch (error) {
    handleApiError(error, 'creating video');
  }
};

const handleCancel = () => {
  router.back();
};

const closeForm = () => {
  router.push(isSuperuser() ? '/admin/publishing' : '/publishing');
};

const fetchChannels = async () => {
  try {
    const response = await axios.get('/api/channels');
    channels.value = response.data;
  } catch (error) {
    handleApiError(error, 'fetching channels');
  }
};

onMounted(async () => {
  if (isSuperuser()) {
    await fetchChannels();
  }
  if (route.params.channel_id) {
    videoForm.value.formData.channel_id = route.params.channel_id;
  }
});
</script>

<style scoped>
@import '@/styles/shared-form.css';
</style>